import { render, staticRenderFns } from "./PartnerSigners.vue?vue&type=template&id=4a0c2bd2"
import script from "./PartnerSigners.vue?vue&type=script&lang=js"
export * from "./PartnerSigners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports